import { Toolbar, IconButton, Typography } from "@material-ui/core";
import * as React from "react";
// import { PortalAppBar } from "src/components/app-bar";
import { observable } from "mobx";
import { createStyles, withStyles, WithStyles } from "@material-ui/core/styles";
import { ArrowBack, PersonAdd } from "@material-ui/icons";
import { history } from "src/history.js";
import { Route, Switch, RouteComponentProps } from "react-router-dom";
import { permissionsStore } from "../modules/Permissions";

const styles = createStyles({
  root: {
    display: "flex",
    height: "4rem",
    // boxShadow:
    //   "0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)",
    borderBottom: "solid 0.5px #194b87",
  },
  leftButton: {
    padding: "20px",
    borderRadius: 0,
    borderRight: "solid .5px #194b87",
  },
  rightButton: {
    padding: "20px",
    borderRadius: 0,
    borderLeft: "solid .5px #194b87",
  },
  title: {
    paddingLeft: "24px",
    paddingRight: "24px",
  },
});

interface IProps {
  pageTitle?: string;
  tabs?: any;
}

class AdminToolBar extends React.Component<WithStyles<typeof styles> & IProps> {
  public state = {
    current_tab: 0,
  };

  constructor(props: any) {
    super(props);
  }

  public navOnClick = (path: string) => () => {
    history.push(path);
  };

  public AddUserButton = () => {
    if (permissionsStore.checkPermissionByCategoryAndType("user", "create")) {
      return (
        <IconButton
          onClick={this.navOnClick("/admin/users/create")}
          className={this.props.classes.rightButton}
        >
          <PersonAdd />
        </IconButton>
      );
    }
    return null;
  };

  public AddCompanyButton = () => {
    if (
      permissionsStore.checkPermissionByCategoryAndType("company", "create")
    ) {
      return (
        <IconButton
          onClick={this.navOnClick("/admin/companies/create")}
          className={this.props.classes.rightButton}
        >
          <PersonAdd />
        </IconButton>
      );
    }
    return null;
  };

  public render() {
    const { classes, pageTitle, tabs } = this.props;
    return (
      /**
       * #TODO B-018 use .back and remove history.goBack
       */
      <Toolbar disableGutters={true} className={classes.root}>
        <IconButton onClick={history.back} className={classes.leftButton}>
          <ArrowBack />
        </IconButton>
        <Typography variant="h6" className={classes.title}>
          {pageTitle || ""}
        </Typography>
        {tabs}
        <div style={{ flex: 1 }} />
        <Route
          path="/admin/users"
          exact={true}
          component={this.AddUserButton}
        />
        <Route
          path="/admin/companies"
          exact={true}
          component={this.AddCompanyButton}
        />
        <Route path="/admin/users" exact={true} />
      </Toolbar>
    );
  }
}

export default withStyles(styles, { withTheme: true })(AdminToolBar);



// WEBPACK FOOTER //
// ./src/modules/admin/components/AdminToolBar.tsx